// Separated the logic for sorting the filters from MergedGroupItems.tsx
import type { DashboardFilter as IDashboardFilter } from '../../../../../../lib/api/looker/dto';
import type {
  FilterConfigGroupItem,
  FilterConfigItem,
  FilterConfigSubGroupItem,
} from '../../FilterConfig/FilterConfigTypes';

export const getMergedDashboardFilters = (filters: IDashboardFilter[], filterConfigItems: FilterConfigItem[]) => {
  return filters?.map((filter) => {
    const filterFromPredefinedMap = filterConfigItems.find(
      (predefinedFilter) => predefinedFilter.filterName === filter.name,
    );

    return {
      ...filterFromPredefinedMap,
      dashboardFilter: { ...filter },
    };
  });
};

export const getSortedAndMergedFilters = (
  group: FilterConfigGroupItem | FilterConfigSubGroupItem,
  dashboardFilters: IDashboardFilter[],
  filterConfigItems: FilterConfigItem[],
) => {
  return getMergedDashboardFilters(dashboardFilters, filterConfigItems)
    ?.filter((filter) => group.filtersInGroup?.find((g) => g.name === filter.dashboardFilter.name))
    .sort((filterA, filterB) => {
      const indexA = group.filtersInGroup?.find((g) => g.name === filterA.dashboardFilter.name)?.index;
      const indexB = group.filtersInGroup?.find((g) => g.name === filterB.dashboardFilter.name)?.index;

      if (!indexA || !indexB) return 0;
      return indexA - indexB;
    });
};

export const sortGroupsPredicate = (groupA: FilterConfigGroupItem, groupB: FilterConfigGroupItem) =>
  groupA.ordinalPosition - groupB.ordinalPosition;
